var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8023 3.7998C18.9083 3.7998 4.40234 18.3058 4.40234 36.1998C4.40234 54.0939 18.9083 68.5998 36.8023 68.5998C54.6964 68.5998 69.2023 54.0939 69.2023 36.1998C69.2023 18.3058 54.6964 3.7998 36.8023 3.7998Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8333 5.07588C43.4604 4.38857 40.9753 3.96525 38.412 3.83984C43.9942 12.6617 47.4494 22.7692 48.4526 33.3077H25.1519C26.1551 22.7692 29.6104 12.6618 35.1925 3.83985C32.6292 3.96527 30.1441 4.38858 27.7712 5.07591C23.0976 13.7484 20.2138 23.3621 19.3421 33.3077H4.52973C4.44541 34.2607 4.40234 35.2256 4.40234 36.2006C4.40234 37.1755 4.44541 38.1404 4.52973 39.0934H19.3421C20.2138 49.039 23.0976 58.6526 27.7712 67.3251C30.1441 68.0125 32.6292 68.436 35.1925 68.5614C29.6103 59.7394 26.1551 49.6319 25.1519 39.0934H48.4526C47.4494 49.6319 43.9942 59.7394 38.412 68.5614C40.9754 68.436 43.4605 68.0125 45.8333 67.3251C50.5069 58.6526 53.3907 49.039 54.2622 39.0934H69.0751C69.1593 38.1404 69.2023 37.1755 69.2023 36.2006C69.2023 35.2256 69.1593 34.2607 69.0751 33.3077H54.2622C53.3907 23.3621 50.5069 13.7483 45.8333 5.07588Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsp1);
export default __webpack_public_path__ + "static/media/dsp_1.681ae94928c3a3ad02b3a326e6e13c75.svg";
export { ForwardRef as ReactComponent };